export const hy = {
  title: "Բնական անտառի ռեգրումից ածխաջրածնային կուտակման պոտենցիալը' անտառապատ տարածքներում",
  subtitle: 'reforestable areas, 1 km, Cook-Patton et al. 2020',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Գործառույթ',
      value:
        'Գնահատում է այն արագությունը, որով ածխածինը կարող էր սեխվել վերգետնյայի կենդանի կենսազանգվածում բնական անտառների վերականգնման առաջին երեսուն տարիների ընթացքում հնարավոր է անտառի վերականգնման ժամանակ (Mg carbon/ha/yr):',
    },
    {
      label: 'Բանաձեւ',
      value: '1 × 1 կմ',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value:
        'Գլոբալ, 2017 թվականի Griscom et al. 2017 -ի (որը բացառում է բորալ, տափաստանային բիոմերը եւ մշակաբույսերը)',
    },
    {
      label: 'Աղբյուր',
      value:
        'Cook-Patton, S.C., S.M. Leavitt, D. Gibbs, N.L. Harris, K. Lister, K.J. Anderson-Teixeira, R.D. Briggs, R.L. Chazdon, T.W. Crowther, P.W. Ellis, H.P. Griscom, V. Herrmann, K.D. Holl, R.A. Houghton, C. Larrosa, G. Lomax, R. Lucas, P. Madsen, Y. Malhi, A. Paquette, J.D. Parker, K. Paul, D. Routh, S. Roxburgh, S. Saatchi, J.van den Hoogen, W.S. Walker, C.E. Wheeler, S.A. Wood, L. Xu, B.W. Griscom. 2020. Mapping carbon accumulation potential from natural forest regrowth. Nature, in press. https://www.nature.com/articles/s41586-020-2686-x. This work resulted from a collaboration between The Nature Conservancy, World Resources Institute, and 18 other institutions.',
    },
    {
      label: 'Հաճախականություն',
      value: '',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: 'Կիրառելի է բնական անտառի ռեգրեգացման առաջին 30 տարիների համար:',
    },
    {
      label: 'Զգուշացումներ',
      value:
        '-Արժեքները ներկայացնում են լավագույն գնահատականները, բայց պարունակում են անորոշություն: Արդյունքների ճշգրտումը կախված է մոդելային ուսուցման տվյալների առկայությունից, որը կենտրոնացված է տասը երկրներում: Այս տվյալների շերտի հետ կապված անորոշության քարտեզը կարելի է ներբեռնել GFW-ի Open Data Portal-ից:\n- Ածխածնի կուտակման ցուցանիշները կիրառելի են միայն բնական անտառի ռեգրեսիվության դեպքում, եւ չեն կիրառվում վերականգնման այլ ակտիվ մեթոդների (ագրոպարեն, պլանտացիա եւ այլն) նկատմամբ:\n- Ածխաջրածնային կուտակումների ցուցանիշները գծային են եւ միջինում կազմում են առաջին 30 տարվա ռեգրեգատը: 30 տարուց ավել երկարացնելը կգնահատի հաջորդականությունը։\n- Ցուցանիշները արտացոլում են ածխածնի կուտակումը միայն վերնահարկի կենդանի կենսազանգվածում: Ստորոտում գտնվող կենսազանգվածում, մեռած օրգանական նյութերում եւ հողի օրգանական ածխաջրածիններում կուտակումները ներառված չեն, սակայն ստորեւ բերված ածխածնի կուտակման քարտեզը հասանելի է խնդրանքով:\n- Սավաններում ցուցանիշները վերաբերում են միայն այդ մարգագետնային-անտառային մատրիցների անտառապատ հատվածներին:\n- Այս տվյալները չեն փոխարինում անտառային ռեգրեգացման ներուժի մանրամասն տեղայնացման մակարդակի գնահատումներին:',
    },
    {
      label: 'Լիցենզիա',
      value: 'CC 4.0',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Այս քարտեզը ցույց է տալիս, թե որքան արագ կարող են անտառները մթնոլորտից կլանել ածխածինը եւ պահել այն վերեւում գտնվող կենդանի կենսազանգվածում բնական անտառների վերականգնման առաջին 30 տարիների ընթացքում։ Այն ստեղծվել է աշխարհի հազարավոր վայրերում հողի վրա հիմնված չափումները միացնելով 66 համատեղ տեղադրված շրջակա միջավայրի կովարիատի շերտերի հետ մեքենայական ուսուցման մոդելում, որպեսզի ստեղծվի պատից պատ ընկած քարտեզ։ Մոդելը մարզելու համար օգտագործվող անտառային հողակտորի տվյալները վերցված են հրատարակված գրականությունից, որը կարելի է գտնել Անտառային ածխածնի տվյալների շտեմարանում (ForC, որը պահպանվում է Սմիթսոնիական ինստիտուտի (https://github.com/forc-db) կողմից), ինչպես նաեւ գեոռեֆերենսացված տվյալներ հանրայնորեն մատչելի ազգային անտառային պաշարներից: Չնայած ցուցանիշները գնահատվել են ամբողջ աշխարհում բոլոր անտառային եւ սավաննա բիոմների նկատմամբ, դրանք այստեղ ֆիլտրված են «անտաշ» տարածքով, ինչպես սահմանված է Griscom et al. 2017 -ում (PNAS): 2.1. 2.1. 2.1. 2.1. 2.1. 2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2.2',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Cook-Patton et al. 2020. Carbon accumulation potential from natural forest regrowth in potentially reforestable areas. Accessed through Global Forest Watch 14/02/2025. www.globalforestwatch.org',
  },
};
